var exports = {
  "D": "Heading__F_unXK",
};

module.exports = exports;
